export const toCapitalized = (word: string): string =>
    word
        .toLowerCase()
        .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
export const toCapitalizedSimple = (word: string): string =>
    word.charAt(0).toUpperCase() + word.slice(1);
